<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center">
      <h2>{{ $tc('unregistered_location', 2) }}</h2>
    </div>
    <table-pagination-controls
      :total-rows="items.length"
      :current-page.sync="currentPage"
      :rows-per-page.sync="rowsPerPage"
      :per-page-options="pageOptions"/>
    <v-data-table
      hide-default-footer
      :items="items"
      :headers="tableFields"
      :loading="loading"
      :page="currentPage"
      :items-per-page="rowsPerPage"
      :loading-text="$t('loading')">
      <template #item.first_received="row">
        <multi-time-display :time="row.value"/>
      </template>
      <template #item.route_plans="row">
        <router-link :to="constructLink(row.item)">
          <span v-if="row.value.length === 1"> {{ row.value[0].route_number }} </span>
          <span v-else> {{ row.value.length }} {{ $tc('route', 2) }}</span>
        </router-link>
      </template>
      <template #item.actions="row">
        <vf-tooltip :text="$t('create_new_location_from_code')">
          <a :href="`/location/create?unregistered=1&code=${row.item.location_code}`" target="_blank">
            <v-icon color="primary">mdi-plus-circle</v-icon>
          </a>
        </vf-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import TablePaginationControls from '@/components/shared/TablePaginationControls'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay.vue'
import VfTooltip from '@/components/shared/VfTooltip'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

import { uniq, map } from 'lodash'

export default {
  name: 'UnregisteredLocations',
  components: {
    TablePaginationControls,
    MultiTimeDisplay,
    VfTooltip
  },
  mixins: [
    CurrentUserMixin,
    BrowserUtilitiesMixin
  ],
  data () {
    return {
      model: 'UnregisteredLocation',
      currentPage: 1,
      rowsPerPage: 20,
      pageOptions: [10, 20, 50, 100],
      items: [],
      loading: false,
      tableFields: [
        {
          value: 'location_code',
          text: this.$tc('code')
        },
        {
          value: 'first_received',
          text: this.$t('first_received')
        },
        {
          value: 'route_plans',
          text: this.$tc('route_plan', 2),
          sortable: false
        },
        {
          value: 'actions',
          text: this.$tc('action', 2),
          sortable: false
        }
      ]
    }
  },
  methods: {
    async fetchItems () {
      try {
        this.loading = true
        const response = await this.$orm('UnregisteredLocation').findAll({
          customer_id: this.customerContext.id,
          expand: 'route',
          fields: 'location_code,first_received,route_plans',
        })
        this.items = response.getItems()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    /**
     * Construct a link that will take us to the appropriate route plans.
     * @return string
     */
    constructLink (unregisteredLocation) {
      const routeNumbers = uniq(map(unregisteredLocation.route_plans, x => x.route_number)).join(',')
      return `/route-plans?routeNumber=${routeNumbers}&stops=${unregisteredLocation.location_code}`
    },
    customerContextChangeHandler () {
      this.fetchItems()
    }
  },
  mounted () {
    this.fetchItems()
    this.updateBrowserTitle(this.$tc('unregistered_location', 2))
  }
}
</script>
